module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-13.a449ef19.png";